import React from 'react';

import "./theme/_main.scss";

import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import { NarrowContainer } from '../../customizations/components/theme/Container/Container';
import { Container } from '../../customizations/components/theme/Container/Container';

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;
    const DecorativeSVG = (
        <svg
            fill="none"
            height="1024"
            viewBox="0 0 1440 1024"
            width="1440"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <clipPath id="a">
                <path d="M0 0h1440v1024H0z" />
            </clipPath>
            <g clipPath="url(#a)" stroke="#3b2ead">
                <path d="M-23.659 273.058c147.973-34.286 323.098-79.674 396.858-36.245s54.302 125.062 14.028 169.471c-40.274 44.408-195.94 151.512-436.227 173.716" />
                <path d="M1156.5-45c-41.33 57.8333-109.9 198.3-53.5 297.5 70.5 124 265 107 395 53.5" />
            </g>
        </svg>
    );


    return (

                <div className="custom-block intro-block">
                    {!isEditMode &&<div className='background'>
                        {DecorativeSVG}
                    </div>}
                    <div className='title'>
                        {isEditMode ? (
                            <>
                                <TextLineEdit
                                    {...filteredToolbarProps}
                                    renderTag="h1"
                                    renderClassName={`documentFirstHeading ${isEditMode && "titleHighlight"}`}
                                    fieldDataName="titleStart"
                                    properties={{ titleStart: data.titleStart }}
                                />
                                <TextLineEdit
                                    {...filteredToolbarProps}
                                    renderTag="h1"
                                    renderClassName="documentFirstHeading titleHighlight"
                                    fieldDataName="titleHighlight"
                                    properties={{ titleHighlight: data.titleHighlight }}
                                />
                                <TextLineEdit
                                    {...filteredToolbarProps}
                                    renderTag="h1"
                                    renderClassName={`documentFirstHeading ${isEditMode && "titleHighlight"}`}
                                    fieldDataName="titleEnd"
                                    properties={{ titleEnd: data.titleEnd }}
                                />
                            </>
                        ) : (
                            <h1 className="documentFirstHeading">
                                <span className='animated'>
                                    {data?.titleStart}
                                    <br />
                                    <span className={"titleHighlight"}>
                                        {data?.titleHighlight}
                                    </span>
                                    <br />
                                    {data?.titleEnd}
                                </span>
                            </h1>
                        )}
                    </div>
                    {isEditMode ? (
                        <TextLineEdit
                            {...filteredToolbarProps}
                            renderTag="h2"
                            renderClassName="documentFirstHeading"
                            fieldDataName="description"
                            properties={{ description: data.description }}
                        />
                    ) : (
                        data?.description &&
                        <h3>
                            <span className='animated'>
                                {data.description}
                            </span>
                        </h3>

                    )}

                    <NarrowContainer>
                        <div className="block video align">
                            <Body data={data} />
                        </div>
                    </NarrowContainer>

                </div>
           
    );
};

export default View;
